export default __webpack_public_path__ + "static/sellars-9c18ed3c345f0f733b5a3c83be3e05e3.jpg";